// extracted by mini-css-extract-plugin
export default {"boxFlex":"c1XbzlsCfBvYVzeEE8I6","boxShrink":"cuRKAC6fzn4r81FvPjk4","boxGrow":"p9MRXzrFYeHTTpXvRevY"};